import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import RandomLengthComponent from "@tCooneyBrothers/Components/RandomLengthComponent";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const productState = getProductStateByPath(state, productPath);
    return {
        parentProductState: productState,
    };
};

type props = WidgetProps & ReturnType<typeof mapStateToProps>;

const RandomLengthItem: React.FC<props> = props => {
    const showDiscontinuedTag = props.parentProductState?.value && props.parentProductState?.value.properties?.discontinuedDate ? 
        new Date(props.parentProductState.value.properties.discontinuedDate) < new Date(): 
        false;
    if(showDiscontinuedTag) {
        return null;
    }
    return (
        <StyledWrapper>
            {props.parentProductState.value?.properties["randomLengthItem"]?.toLowerCase() === "true" ? (
                <RandomLengthComponent displayRandomLength={true}></RandomLengthComponent>
            ) : null}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, undefined)(RandomLengthItem),
    definition: {
        displayName: "RandomLengthItem",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
